// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"FooterPageLayout_footerWrapper__XDaaj","footerText":"FooterPageLayout_footerText__7Dnc7","iconWrapper":"FooterPageLayout_iconWrapper__3QCBj"};